import { getShortLoopName } from '../utils';

const EMPTY_LOOPS_DEFINITIONS = Object.freeze({});
const EMPTY_ITEMS_BY_ID = Object.freeze({});

function getFlow(registry, flowId) {
    return registry.get(flowId);
}

function getItemsById(registry, flowId) {
    const flow = getFlow(registry, flowId);
    if (!flow) return EMPTY_ITEMS_BY_ID;
    const map = {};
    for (const it of flow.items) map[it.id] = it;
    return map;
}

export function selectCurrentItem(state, registry) {
    return getItemsById(registry, state.currentFlowId)[state.currentItemId] || null;
}

export function selectCurrentLoopName(state, registry) {
    const item = selectCurrentItem(state, registry);
    return (item && item.loopName) || null;
}

export function selectCurrentLoop(state, registry) {
    const name = selectCurrentLoopName(state, registry);
    const loops = state.loops || {};
    return name ? loops[name] || null : null;
}

export function selectLoopsDefinitions(state, registry) {
    const flow = getFlow(registry, state.currentFlowId);
    return (flow && flow.loopsDefinitions) || EMPTY_LOOPS_DEFINITIONS;
}

export function selectFlowsList(registry) {
    // defensive: tolerate registries without listFlows (e.g. plain objects in tests)
    if (typeof registry.listFlows === 'function') return registry.listFlows();
    return [];
}

export function selectLoopIterationName(loopName, iteration, state, registry) {
    const loops = state.loops || {};
    const defs = selectLoopsDefinitions(state, registry);
    const short = getShortLoopName(loopName);
    const def = defs[short];
    if (def && typeof def.getIterationName === 'function') {
        try {
            const name = def.getIterationName(
                state.globals,
                loops[loopName] ? loops[loopName].states : undefined,
                iteration,
                loops,
                state.itemsStates,
            );
            if (name && String(name).trim()) return String(name).trim();
        } catch (e) {
            return String(iteration);
        }
    }
    return String(iteration);
}
